export default class CDSUploadAdapter {
	constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
				var formData = new FormData();
				formData.append('source', 'WEBSITE')
				formData.append('context', 'CONTENT')
				formData.append('variation', 'large')
				formData.append('upload_file', file);
				// need to send the login token with all API requests!
    		    let re = new RegExp("dashboard_token=([^;]+)");
                let cookieToken = re.exec(document.cookie)
                let dashbordToken = (cookieToken != null) ? unescape(cookieToken[1]) : null
				formData.append('fd_token', dashbordToken)
				let headers = {
					method: 'post',
					body: formData,
					credentials: 'include'
				}
                var api = (document.location.hostname.indexOf('.test') > -1) ? 'https://cdsapi.test/' : document.location.protocol + '//' + document.location.hostname + '/api/'
				fetch(api + 'api.php?action=upload_site_image', headers).then(function(response) {
					return response.json()
				}).then(obj => {
					resolve({
		                default: obj.image.image_src
		            })
					success()
				}).catch(error => {
					reject(error)
				})
        } ) );
    }

    // Aborts the upload process.
    abort() {
        // Do nothing???
    }
}
